import { ReportTemplate } from "./models/report-template";
import { IReportAM } from "./report-api";
import { Disposable, autoinject } from "aurelia-framework";

export class ReportRouteStore implements Disposable {
	dispose(): void {
		this.cache = {};
	}
	cache: { [key: string]: any } = {};
	fromCache<T>(id?: string): T {
		if (!id) {
			id = 'preview';
		}
		return this.cache[id] as T;
	}
	toCache<T>(input: T, id?: string) {
		this.cache[id || 'preview'] = input;
	}
}

@autoinject
export class NewReportPreviewSwapStore implements Disposable {
	constructor(private routeStore: ReportRouteStore) { }
	dispose(): void {
		this.routeStore.cache['preview'] = null;
	}
	set store(value: any) {
		this.routeStore.cache['preview'] = value;
	}
	fromCache<T>() {
		return this.routeStore.fromCache<T>('preview');
	}
}

@autoinject
export class ReportEditSwapStore implements Disposable {
	constructor(private routeStore: ReportRouteStore) { }
	dispose(): void {
		this.routeStore.dispose();
	}
	set store(value: IReportAM) {
		this.routeStore.cache[value.reportTemplateId] = value;
	}
}
